import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  characters: [],
  singleRegister: [],
};


const slice = createSlice({
  name: 'character',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET spell
    getcharacteruccess(state, action) {
      state.isLoading = false;
      state.characters = action.payload;
    },
    getsingleregister(state, action) {
      state.isLoading = false;
      state.singleRegister = action.payload;
    },

  },
});

// Reducer
export default slice.reducer;


export function getCharacter(currentUser, paginate, pageIndex, pageSize) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const params = {};
      if (paginate) params.paginate = paginate;
      if (pageIndex) params.page = pageIndex;
      if (pageSize) params.per_page = pageSize;
      const url = currentUser === 'admin' ? '/api/admin/manage_registrations' : '/api/manage_registrations';
      const response = await axios.get(url, { params });
      dispatch(slice.actions.getcharacteruccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSingleRegister(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/admin/manage_registrations/${id}`);
      dispatch(slice.actions.getsingleregister(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

